import requester from '@/lib/axios';
import { AssessmentItem } from '@/models/Assessment';

const buildBaseUrl = (evaluationId: number, assessmentId: number) =>
  `evaluations/${evaluationId}/assessments/${assessmentId}/items`;

export const createAssessmentItem = async (
  evaluationId: number,
  assessmentId: number,
  body: Partial<AssessmentItem>,
) => {
  const { data } = await requester().post<AssessmentItem>(
    `${buildBaseUrl(evaluationId, assessmentId)}/`,
    body,
  );
  return data;
};

export const updateAssessmentItem = async (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
  body: Partial<AssessmentItem>,
) => {
  const { data } = await requester().patch<AssessmentItem>(
    `${buildBaseUrl(evaluationId, assessmentId)}/${itemId}/`,
    body,
  );
  return data;
};

export const deleteAssessmentItem = async (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
) => {
  await requester().delete<void>(
    `${buildBaseUrl(evaluationId, assessmentId)}/${itemId}/`,
  );
};
